/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The status of the primary channel of the message.
 */
export type MessagePrimaryChannelStatus =
  (typeof MessagePrimaryChannelStatus)[keyof typeof MessagePrimaryChannelStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessagePrimaryChannelStatus = {
  ACTIVE: "ACTIVE",
  DELIVERED: "DELIVERED",
  STALLED: "STALLED",
  FAILED: "FAILED",
} as const;
